import { authenticatedFastApiAxiosInstanceAllowEmptyString } from "@/lib/data/http";
import { baseFastApiMatterRoute } from "@/lib/data/requests/matters/matter";
import { type APIResponse, type User } from "@/lib/types";
import { type MatterTaskComment } from "../../../types/Matter";

type AnnotationParentInput =
  | { matterId: string; massTortId?: never }
  | { matterId?: never; massTortId: string };

export const createMatterTaskCommentV1 = (
  data: Pick<MatterTaskComment, "message" | "taskId"> &
    AnnotationParentInput & { user: User },
) => {
  const { message, ...rest } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .post<APIResponse<MatterTaskComment>>(
      `${baseFastApiMatterRoute}/tasks/comments`,
      {
        ...rest,
        message: message,
      },
    )
    .then((res) => res.data);
};

type UpdateMatterTaskCommentInput = Pick<
  MatterTaskComment,
  "id" | "dateModified" | "message" | "taskId"
> &
  AnnotationParentInput &
  Partial<MatterTaskComment>;

export const updateMatterTaskCommentV1 = (
  data: UpdateMatterTaskCommentInput,
) => {
  const { id, ...rest } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .patch<APIResponse<MatterTaskComment>>(
      `${baseFastApiMatterRoute}/tasks/comments`,
      {
        ...rest,
        id,
      },
    )
    .then((res) => res.data);
};

export const deleteMatterTaskCommentV1 = (
  data: Pick<MatterTaskComment, "id"> & AnnotationParentInput,
) => {
  const { id } = data;
  return authenticatedFastApiAxiosInstanceAllowEmptyString
    .delete<
      APIResponse<MatterTaskComment>
    >(`${baseFastApiMatterRoute}/tasks/comments/${id}`)
    .then((res) => res.data);
};
